import { render, staticRenderFns } from "./greetingsDetail.vue?vue&type=template&id=1afdfbf5&scoped=true"
import script from "./greetingsDetail.vue?vue&type=script&lang=js"
export * from "./greetingsDetail.vue?vue&type=script&lang=js"
import style0 from "./greetingsDetail.vue?vue&type=style&index=0&id=1afdfbf5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afdfbf5",
  null
  
)

export default component.exports